module.exports = __webpack_public_path__ + "static/media/undraw_having_fun_iais.91d225d6.png";